import React, { useContext } from 'react';
import L from 'leaflet';
import { Typography } from '@material-ui/core';
import { Marker, Popup } from 'react-leaflet';

import { PreferLocationContext } from '../../../../services/prefer-location/prefer-location.context';

export const MarkerPlaces = () => {
  const { setLocationSelected, type, place } = useContext(PreferLocationContext);

  return (
    <>
      {place &&
        place.map((item, index) => (
          <Marker
            key={index}
            position={[
              item.geometry.coordinates[1],
              item.geometry.coordinates[0],
            ]}
            icon={L.icon({
              iconUrl: `/icons/marker_${type}_icon.webp`,
              iconSize: [28, 42],
              iconAnchor: [15.5, 42],
              popupAnchor: [0, -45],
            })}
            eventHandlers={{
              click: (e) => {
                setLocationSelected({
                  places: [
                    {
                      lat: item.geometry.coordinates[1],
                      lng: item.geometry.coordinates[0],
                      name: item.properties.address_line1,
                      address: item.properties.address_line2,
                      type: type === 'fast_food' ? 'fastfood' : type,
                    },
                  ],
                });
                // getPlace([item]);
              },
            }}
          >
            <Popup>
              <Typography variant='h6' color='secondary'>
                This location was selected.
              </Typography>
              <Typography variant='subtitle1'>
                {item.properties.address_line1}
              </Typography>
              <Typography variant='caption'>
                {item.properties.address_line2}
              </Typography>
            </Popup>
          </Marker>
        ))}
    </>
  );
};
